import { makeStyles } from "@material-ui/core";
import React from "react";
import { DeleteButton, SaveButton, Toolbar as RaToolbar } from "react-admin";
import SafeTag from "../components/SafeTag";
import CreateChannelsButton from "./CreateChannelsButton";
import ImportButton from "./ImportButton";

const useStyles = makeStyles((theme) => ({
	toolbar: {
		paddingLeft: theme.spacing(2),
		justifyContent: "space-between",
		display: "flex",
	},
	button: {
		marginRight: theme.spacing(1),
		overflow: "hidden",
	},
}));

const Toolbar = ({ basePath, ...props }) => {
	const classes = useStyles();
	return (
		<RaToolbar {...props} className={classes.toolbar}>
			<SaveButton
				className={classes.button}
				redirect="list"
				disabled={props.pristine}
				submitOnEnter={true}
			/>
			<SafeTag>
				<ImportButton
					isButton={true}
					variant="contained"
					record={props.record}
					disableElevation
				/>
				&nbsp;
				<CreateChannelsButton
					isButton={true}
					variant="contained"
					record={props.record}
					disableElevation
				/>
			</SafeTag>
			<DeleteButton />
		</RaToolbar>
	);
};

export default Toolbar;
